import { Button, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, Portal } from '@chakra-ui/react'
import React from 'react'
import RequiredJobTitle from './RequiredJobTitle.js/RequiredJobTitle'

const RequiredJobTitlePopOver = ({ requiredJobTitle, setRequiredJobTitle, onCloseRequiredJobTitlePopOver }) => {
    return (
        <Popover placement="top" closeOnBlur={false}   onClose={onCloseRequiredJobTitlePopOver}>
            <PopoverTrigger>
                <Button
                    size="sm"
                    colorScheme="blue"
                    variant="ghost"
                    mr={2}
                >
                    Click here to update required job titles
                </Button>
            </PopoverTrigger>
            <Portal>
                <PopoverContent>
                    <PopoverArrow />
                    <PopoverHeader> Enter required job titles</PopoverHeader>
                    <PopoverCloseButton />
                    <PopoverBody>
                        <RequiredJobTitle tags={requiredJobTitle} setTags={setRequiredJobTitle} />
                    </PopoverBody>
                </PopoverContent>
            </Portal>
        </Popover>
    )
}

export default RequiredJobTitlePopOver